import type { AxiosError } from 'axios';

export function extractApiMessage(error: unknown, fallback = 'Ocurrió un error inesperado'): string {
  const axiosErr = error as AxiosError<{ message?: string; error?: string }>;
  const data = axiosErr.response?.data;
  if (typeof data?.message === 'string' && data.message.trim()) return data.message;
  if (typeof data?.error === 'string' && data.error.trim()) return data.error;
  if (error instanceof Error && error.message.trim()) return error.message;
  return fallback;
}
